<template>
  <div>
    <div style="height: 40px;width: 100%;margin-top: -20px" v-if="!(deviceRow.devicetype === 902 || deviceRow.devicetype === 351 ||
    deviceRow.devicetype === 352 || deviceRow.devicetype === 353)">
      <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
      <div class="add-open-btn" v-if="indexActive !== 0 && indexActive !== 4 && indexActive !== 5" @click="addOpen()">
        <strong>+</strong>
      </div>
    </div>
    <div v-if="indexActive === 0">
      <sub-list ref="sub" :device="deviceRow" @getDataEnd="getDataEnd"></sub-list>
    </div>
    <div v-if="indexActive === 1">
      <tel-book ref="telBook" :telObj="deviceRow"></tel-book>
    </div>
    <div v-if="indexActive === 2">
      <did-voice-details ref="voice" :voiceObj="voiceObj"></did-voice-details>
    </div>
    <div v-if="indexActive === 3">
      <fm-info ref="fm" :fmObj="fmObj"></fm-info>
    </div>
    <div v-if="indexActive === 4">
      <div class="sos-phone">
        <el-row>
          <el-col :span="8"><span>SOS呼叫号码&nbsp;</span><el-input type="number" style="width: 150px" placeholder="请输入号码" v-model="sosPhone.phone1"></el-input></el-col>
          <el-col :span="8" v-if="deviceRow.devicetype === 902"><span>&nbsp;&nbsp;&nbsp;按键1号码&nbsp;&nbsp;</span><el-input type="number" style="width: 160px" placeholder="请输入号码" v-model="sosPhone.phone2" clearable></el-input></el-col>
          <el-col :span="8" v-if="deviceRow.devicetype === 902"><span>&nbsp;&nbsp;&nbsp;按键2号码&nbsp;&nbsp;</span><el-input type="number" style="width: 160px" placeholder="请输入号码" v-model="sosPhone.phone3" clearable></el-input></el-col>
        </el-row>
      </div>
      <div style="height: 30px;margin: 20px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitSOSphone()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <div v-if="indexActive === 5">
      <div class="sos-phone">
        <span>设置时长&nbsp;</span>
        <el-select v-fixZoom v-model="selectTime" filterable placeholder="请选择" style="width: 200px">
          <el-option v-for="item in timeArr" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-input v-if="selectTime === 0" type="number" style="width: 260px" placeholder="范围10~40之内" :min="10" :max="40" v-model="otherTime" clearable>
          <template slot="append">分钟</template>
        </el-input>
      </div>
      <div style="height: 30px;margin: 20px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitSet()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
    <!--  351 352 353智能胸卡 设置亲情号码  -->
    <div v-if="indexActive === 6 && (deviceRow.devicetype === 351 || deviceRow.devicetype === 352 || deviceRow.devicetype === 353)">
      <div class="sos-phone">
        <el-row>
          <el-col :span="12"><span>SOS呼叫号码1&nbsp;&nbsp;</span><el-input type="number" style="width: 255px" placeholder="请输入" v-model="familyPhone.phone4"></el-input></el-col>
          <el-col :span="12"><span>SOS呼叫号码2&nbsp;&nbsp;</span><el-input type="number" style="width: 255px" placeholder="请输入号码" v-model="familyPhone.phone5" clearable></el-input></el-col>
        </el-row>
      </div>
      <div class="sos-phone" style="margin-top: 20px" v-if="deviceRow.devicetype === 353">
        <el-row style="margin-bottom: 15px">
          <el-col :span="12"><span>亲情号码1&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="familyPhone.phone1"></el-input></el-col>
          <el-col :span="12"><span>姓名1&nbsp;&nbsp;</span><el-input style="width: 180px" placeholder="请输入" v-model="familyPhone.name1" clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom: 15px">
          <el-col :span="12"><span>亲情号码2&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="familyPhone.phone2" clearable></el-input></el-col>
          <el-col :span="12"><span>姓名2&nbsp;&nbsp;</span><el-input style="width: 180px" placeholder="请输入" v-model="familyPhone.name2" clearable></el-input></el-col>
        </el-row>
        <el-row style="margin-bottom: 15px">
          <el-col :span="12"><span>亲情号码3&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="familyPhone.phone3" clearable></el-input></el-col>
          <el-col :span="12"><span>姓名3&nbsp;&nbsp;</span><el-input style="width: 180px" placeholder="请输入" v-model="familyPhone.name3" clearable></el-input></el-col>
        </el-row>
        <el-row>
          <el-col :span="12"><span>亲情号码4&nbsp;&nbsp;</span><el-input type="number" style="width: 180px" placeholder="请输入" v-model="familyPhone.reserved1" clearable></el-input></el-col>
          <el-col :span="12"><span>姓名4&nbsp;&nbsp;</span><el-input style="width: 180px" placeholder="请输入" v-model="familyPhone.name4" clearable></el-input></el-col>
        </el-row>
      </div>
      <div class="sos-phone" style="margin-top: 20px" v-else>
        <el-row>
          <el-col :span="8"><span>亲情号码1&nbsp;&nbsp;</span><el-input type="number" style="width: 160px" placeholder="请输入" v-model="familyPhone.phone1"></el-input></el-col>
          <el-col :span="8"><span>亲情号码2&nbsp;&nbsp;</span><el-input type="number" style="width: 160px" placeholder="请输入" v-model="familyPhone.phone2" clearable></el-input></el-col>
          <el-col :span="8"><span>亲情号码3&nbsp;&nbsp;</span><el-input type="number" style="width: 160px" placeholder="请输入" v-model="familyPhone.phone3" clearable></el-input></el-col>
        </el-row>
      </div>
      <div style="height: 30px;margin: 20px 100px 0">
        <el-row>
          <el-col :span="12"><div class="cancel-btn" @click="closeOpen()"><span>取消</span></div></el-col>
          <el-col :span="12"><div class="send-btn" @click="submitFamilyphone()"><span>确定</span></div></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import subList from '../childComponents/subList'
import telBook from '../childComponents/telBook'
import didVoiceDetails from '../childComponents/didVoiceDetails'
import fmInfo from './fmInfo'
import {querycommand, querydevicemqttbyimei, sendcommand, setdevicealarminterval} from '../../../api/device'

export default {
  name: 'listTabs',
  components: {subList, telBook, didVoiceDetails, fmInfo},
  model: {
    prop: 'listShow',
    event: 'change'
  },
  props: {
    listObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '子机详情'},
        {index: 1, name: '通讯录设置'},
        {index: 2, name: '语音通知'},
        {index: 3, name: 'FM频率设置'},
        {index: 4, name: 'SOS呼叫号码'}
      ],
      indexActive: 0,
      deviceRow: '',
      voiceObj: {
        org: [],
        device: '',
        community: [],
        home: [],
        push_type: 2, // 1 组织批量 2 指定设备 3 小区批量 4家庭批量
        push_mqtttopic: ''
      },
      fmObj: {
        deviceRow: ''
      },
      // 4、SOS呼叫号码
      sosPhone: {
        phone1: '',
        phone2: '',
        phone3: ''
      },
      // 5 设置滞留报警时长
      selectTime: '',
      otherTime: '',
      timeArr: [
        {id: 600, name: '10分钟'},
        {id: 1200, name: '20分钟'},
        {id: 1800, name: '30分钟'},
        {id: 2400, name: '40分钟'},
        {id: 0, name: '自定义时长'}
      ],
      // 6、亲情号码
      familyPhone: {
        phone1: '',
        phone2: '',
        phone3: '',
        phone4: '',
        phone5: '',
        reserved1: '',
        name1: '',
        name2: '',
        name3: '',
        name4: ''
      }
    }
  },
  created () {
    this.deviceRow = this.listObj.deviceRow
    console.log(this.deviceRow)
    if (this.deviceRow.devicetype === 902) {
      this.indexActive = 4 // 902只保留SOS呼叫号码
    } else if (this.deviceRow.devicetype === 351 || this.deviceRow.devicetype === 352 || this.deviceRow.devicetype === 353) {
      this.indexActive = 6
    }
    this.voiceObj.device = this.deviceRow
    this.fmObj.deviceRow = this.deviceRow
    this.getPushMqttByImei()
    this.getDeviceCommand() // SOS呼叫号码
  },
  methods: {
    getPushMqttByImei () {
      let data = {
        imei: this.deviceRow.deviceid
      }
      querydevicemqttbyimei(data).then(res => {
        this.voiceObj.push_mqtttopic = res.data.device.mqttlevel
      }).catch(() => {})
    },
    getDeviceCommand () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id
      }
      querycommand(data).then(res => {
        let vm = this
        let resDatas = res.data
        if (resDatas !== null) {
          // debugger
          for (let i = 0; i < resDatas.length; i++) {
            let resData = resDatas[i]
            let key = resData.key
            if (key === 'deviceset') {
            } else if (key === 'strandedalarm') {
              let vals = resData.value.split('#')
              let time = vals[vals.length - 1]
              let type = [600, 1200, 1800, 2400]
              if (type.indexOf(parseInt(time)) === -1) {
                this.selectTime = 0
                this.otherTime = parseInt(time) / 60
              } else {
                this.selectTime = parseInt(time)
              }
            } else {
              let value = JSON.parse(resData.value)
              if (key === 'setalarmcallphone') {
                vm.sosPhone.phone1 = value.command1
              } else if (key === 'community') {
                if (this.deviceRow.devicetype === 902) {
                  vm.sosPhone.phone2 = value.command1
                  vm.sosPhone.phone3 = value.command2
                } else if (this.deviceRow.devicetype === 353) {
                  // 解析逗号分隔的电话号码和姓名
                  let phones = value.command1 ? value.command1.split(',') : []
                  let names = value.command2 ? value.command2.split(',') : []
                  vm.familyPhone.phone1 = phones[0] || ''
                  vm.familyPhone.phone2 = phones[1] || ''
                  vm.familyPhone.phone3 = phones[2] || ''
                  vm.familyPhone.reserved1 = phones[3] || ''
                  vm.familyPhone.name1 = names[0] || ''
                  vm.familyPhone.name2 = names[1] || ''
                  vm.familyPhone.name3 = names[2] || ''
                  vm.familyPhone.name4 = names[3] || ''
                  vm.familyPhone.phone4 = value.command4
                  vm.familyPhone.phone5 = value.command5
                } else if (this.deviceRow.devicetype === 351 || this.deviceRow.devicetype === 352) {
                  console.log('===', value)
                  vm.familyPhone.phone1 = value.command1
                  vm.familyPhone.phone2 = value.command2
                  vm.familyPhone.phone3 = value.command3
                }
              }
            }
          }
        }
      }).catch(() => {})
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    addOpen () {
      if (this.indexActive === 0) {
        this.$refs.sub.openSub()
      } else if (this.indexActive === 1) {
        this.$refs.telBook.addTel()
      } else if (this.indexActive === 2) {
        this.$refs.voice.addVoice()
      } else if (this.indexActive === 3) {
        this.$refs.fm.getOpenAdd()
      }
    },
    getDataEnd (obj) {
      if (obj.show) {
        let aa = false
        this.tabs.forEach(item => {
          if (item.index === 5) {
            aa = true
          }
        })
        if (!aa) {
          this.tabs.push({index: 5, name: '设置滞留报警'})
        }
      }
    },
    // SOS呼叫号码
    closeOpen () {
      this.$emit('change', false)
    },
    submitSOSphone () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'setalarmcallphone',
        command1: this.sosPhone.phone1,
        command2: '',
        command3: '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        if (this.deviceRow.devicetype === 902) {
          this.submitSOSphone1()
        } else {
          this.$notify({ title: '成功', message: '成功设置SOS呼叫号码', type: 'success', duration: 2000 })
          this.$emit('change', false)
        }
      }).catch(() => {})
    },
    submitSOSphone1 () {
      let data = {
        imei: this.deviceRow.deviceid,
        did: this.deviceRow.id,
        method: 'community',
        command1: this.sosPhone.phone2,
        command2: this.sosPhone.phone3,
        command3: '',
        command4: '',
        command5: '',
        reserved1: '',
        reserved2: ''
      }
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '成功设置SOS呼叫号码', type: 'success', duration: 2000 })
        this.$emit('change', false)
      }).catch(() => {})
    },
    submitFamilyphone () {
      // if (this.familyPhone.phone1 === '' && this.familyPhone.phone2 === '' && this.familyPhone.phone3 === '') {
      //   this.$message({ message: '请填写亲情号码。', type: 'warning' })
      //   return
      // }
      let data = {}
      if (this.deviceRow.devicetype === 353) {
        // 将4个号码和4个姓名分别合并为逗号分隔的字符串，空值也要保留位置
        let phones = [this.familyPhone.phone1 || '', this.familyPhone.phone2 || '', this.familyPhone.phone3 || '', this.familyPhone.reserved1 || ''].join(',')
        let names = [this.familyPhone.name1 || '', this.familyPhone.name2 || '', this.familyPhone.name3 || '', this.familyPhone.name4 || ''].join(',')
        data = {
          imei: this.deviceRow.deviceid,
          did: this.deviceRow.id,
          method: 'community',
          command1: phones,
          command2: names,
          command3: '',
          command4: this.familyPhone.phone4,
          command5: this.familyPhone.phone5,
          reserved1: '',
          reserved2: this.deviceRow.devicetype + ''
        }
      } else {
        data = {
          imei: this.deviceRow.deviceid,
          did: this.deviceRow.id,
          method: 'community',
          command1: this.familyPhone.phone1,
          command2: this.familyPhone.phone2,
          command3: this.familyPhone.phone3,
          command4: this.familyPhone.phone4,
          command5: this.familyPhone.phone5,
          reserved2: this.deviceRow.devicetype + ''
        }
      }
      sendcommand(data).then(res => {
        this.$notify({ title: '成功', message: '成功设置呼叫号码', type: 'success', duration: 2000 })
        this.$emit('change', false)
      }).catch(() => {})
    },
    submitSet () {
      if (this.selectTime === '') {
        this.$message({message: '请选择时长。', type: 'warning'})
        return
      }
      if (this.selectTime === 0) {
        if (this.otherTime === '') {
          this.$message({message: '请输入自定义时长。', type: 'warning'})
          return
        } else if (parseFloat(this.otherTime) < 10 || parseFloat(this.otherTime) > 40) {
          this.$message({message: '自定义时长范围10~40分钟之内。', type: 'warning'})
          return
        }
      }
      let interval = parseFloat(this.selectTime)
      if (this.selectTime === 0) {
        interval = parseFloat(this.otherTime) * 60
      }
      let data = {
        did: this.deviceRow.id,
        imei: this.deviceRow.deviceid,
        interval: interval
      }
      setdevicealarminterval(data).then(res => {
        this.$notify({title: '成功', message: '成功设置滞留报警时长', type: 'success', duration: 2000})
        this.$emit('change', false)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.sos-phone{
  color: #333333;
  font-size: 16px;
  letter-spacing: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/listTabs.vue